import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {bindDispatch} from 'app/utils/redux';

import Loader from 'react-loader-advanced';

import * as uiHelper from 'dk-ui-lib/lib/utils/uiHelper';
import * as routePath from 'app/utils/routePath';
import * as cookie from 'app/utils/cookie';
import {getCurrentPath} from 'app/utils';
import {history} from 'store';

import Theme from 'app/theme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import Header from './Header'
import {AppErrorInfoDialog, MaterialLoader} from 'dk-ui-lib';

const headerRoutes = _.omit(routePath, ['rootRoute', 'forgetPasswordRoute', 'resetPasswordRoute']);

class Layout extends React.Component {

  getChildContext() {
    return {
      muiTheme: getMuiTheme(Theme.base)
    }
  }

  showErrorDialog(errorInfo) {
    if (this.appErrorInfoDialog) {
      this.appErrorInfoDialog.handleOpen(errorInfo);
    }
  }

  componentDidMount() {
    let currentPath = getCurrentPath(this.props.routing);

    let loginToken = cookie.get(cookie.KEY_LOGIN_TOKEN);

    if(loginToken && !this.props.app.initialized) {
      this.props.actions.loadApp();
    }

    if (_.find(routePath, path => path === currentPath)) {
        this.redirectBasedOnLoginToken(currentPath);
    }
  }

  isAppBusy() {
    let {app} = this.props
    app.isBusy ? uiHelper.disablePageScroll() : uiHelper.enablePageScroll();
    return app.isBusy;
  }

  componentWillReceiveProps(nextProps) {

    let currentPath = getCurrentPath(nextProps.routing);

    if(getCurrentPath(this.props.routing) !== currentPath && _.find(routePath, path => path === currentPath)) {
      this.redirectBasedOnLoginToken(currentPath);
    }

    if (nextProps.app.error) {
      this.showErrorDialog(nextProps.app.error)
    }
  }

  redirectBasedOnLoginToken(currentPath) {
    let loginToken = cookie.get(cookie.KEY_LOGIN_TOKEN);

    if (loginToken && currentPath !== routePath.rootRoute) {
      // history.replace(currentPath);
    } else if(loginToken && currentPath === routePath.rootRoute) {
      history.replace(routePath.dashboardRoute);
    } else if(!loginToken &&
     (currentPath.includes(routePath.forgetPasswordRoute) || currentPath.includes(routePath.resetPasswordRoute))) {
      // history.replace(routePath.forgetPasswordRoute);
    }
    else {
      history.replace(routePath.rootRoute);
    }

  }

  renderHeader(currentPath) {
    if(cookie.get(cookie.KEY_LOGIN_TOKEN) && _.find(headerRoutes, path => path===currentPath)){
      return <Header logoutUser={this.props.actions.logoutUser} currentPath={currentPath}/>
    }
  }


  render() {
    let {routing, children, actions} = this.props;
    return (
     <Loader show={this.isAppBusy()} backgroundStyle={uiHelper.PAGE_LOADER_STYLE} message={<MaterialLoader/>}>
        <div>
          {this.renderHeader(getCurrentPath(routing))}
          {children}
        </div>
        <AppErrorInfoDialog
          ref={component => this.appErrorInfoDialog = component}
          showAppError={actions.showAppError}/>
      </Loader>
    );
  }
}

Layout.childContextTypes = {
  muiTheme: PropTypes.object
}

const selector = createSelector(
  state => state.app,
  state => state.routing,
  (app, routing) => ({ app, routing })
);

export default connect(selector, bindDispatch)(Layout);



// WEBPACK FOOTER //
// ./src/app/views/Layout.js